import {
  ArrangementCronAdminPerformanceSectionId,
  ArrangementCronOverviewSectionId,
  ArrangementCronTrendsSectionId,
  ArrangmentCronSectionId,
} from '../../../core/enums/dashboard-cards.enum';

export interface ArrangmentCronSectionDef {
  id: string;
  title: string;
}

export interface ArrangmentCronSectionLayoutItem {
  id: string;
  visible: boolean;
  colSpan: number;
  order: number;
}

/** Section catalogs aligned with each tab's live UI. */
export const ARRANGMENT_CRON_TAB_SECTIONS: Record<
  ArrangmentCronSectionId,
  ArrangmentCronSectionDef[]
> = {
  [ArrangmentCronSectionId.OVERVIEW]: [
    { id: ArrangementCronOverviewSectionId.SYSTEM_INTEL, title: 'System Intel Arrangement Cron' },
    { id: ArrangementCronOverviewSectionId.SCHEDULED_TODAY, title: 'Scheduled Today' },
    { id: ArrangementCronOverviewSectionId.RECENT_ATTEMPTS, title: 'Recent Attempts' },
    { id: ArrangementCronOverviewSectionId.KPI_SUMMARY, title: 'Arrangement Core KPI Summary Cards' },
    { id: ArrangementCronOverviewSectionId.TIME_GAP_DISTRIBUTION, title: 'Average Distribution by Time Gap Cards' },
    { id: ArrangementCronOverviewSectionId.QUICK_ACTION, title: 'Quick Action' },
    { id: ArrangementCronOverviewSectionId.AR_AGING_OVERVIEW, title: 'Accounts Receivable Aging Overview' },
    { id: ArrangementCronOverviewSectionId.MONTHLY_DISTRIBUTION, title: 'Arrangement Distribution' },
    { id: ArrangementCronOverviewSectionId.CREATION_LIFECYCLE, title: 'Creation Date Lifecycle' },
    { id: ArrangementCronOverviewSectionId.CONTRACT_STATUS_CHART, title: 'Arrangements by Contract Status' },
    { id: ArrangementCronOverviewSectionId.METRIC_ANOMALIES, title: 'System Metric Anomalies (Duplicates and Deletions)' },
    { id: ArrangementCronOverviewSectionId.ADMIN_DUPLICATES_TABLE, title: 'Duplicates by Admin Breakdown Table' },
  ],
  [ArrangmentCronSectionId.TRENDS_RECOVERY]: [
    { id: ArrangementCronTrendsSectionId.STATS, title: 'Total stats' },
    { id: ArrangementCronTrendsSectionId.RECOVERY_AMOUNT, title: 'Volume Success Recovery Amount' },
    { id: ArrangementCronTrendsSectionId.CRITICAL_INSIGHTS, title: 'Critical Insights & Opportunities' },
    { id: ArrangementCronTrendsSectionId.MONTH_RECOVERY_PERFORMANCE, title: 'Monthly Recovery Performance' },
    { id: ArrangementCronTrendsSectionId.ARRANGEMENT_TYPES, title: 'Arrangement Types' },
    { id: ArrangementCronTrendsSectionId.SUCCESS_FAILURE_TIME, title: 'Success vs Failure by Time Slot' },
    { id: ArrangementCronTrendsSectionId.SCHEDULE_RECOVERED_AMOUNT, title: 'Daily Scheduled Vs Recovered Amount' },
    { id: ArrangementCronTrendsSectionId.SUCCESS_RATE_COMPARISON_BY_TYPE, title: 'Success Rate Comparison By Type' },
    { id: ArrangementCronTrendsSectionId.ARRANGEMENT_CATEGORIES, title: 'Arrangement Categories' },
    { id: ArrangementCronTrendsSectionId.RECOVERY_VALUE_ATTEMPT, title: 'Recovery Value by Arrangement Attempt' },
    { id: ArrangementCronTrendsSectionId.RECOVERY_EXECUTION_TIMING, title: 'Recovery by Execution Timing' },
    { id: ArrangementCronTrendsSectionId.YOY_PERFORMANCE, title: 'Year-Over-Year Performance' },
  ],
  [ArrangmentCronSectionId.ADMIN_PERFORMANCE]: [
    { id: ArrangementCronAdminPerformanceSectionId.STATS_SUMMARY_OVERVIEW, title: 'Admin Performance Stats Summary Overview' },
    { id: ArrangementCronAdminPerformanceSectionId.TOP_PERFORMER, title: 'Top Performer' },
    { id: ArrangementCronAdminPerformanceSectionId.DUPLICATE_CRISIS, title: 'Duplicate Crisis' },
    { id: ArrangementCronAdminPerformanceSectionId.AVG_RECOVERY_PER_ADMIN, title: 'Avg. Recovery Per Admin' },
    { id: ArrangementCronAdminPerformanceSectionId.DUPLICATE_ENTRY_TREND_OVER_TIME, title: 'Duplicate Entry Trend Over Time' },
    { id: ArrangementCronAdminPerformanceSectionId.DUPLICATE_TREND_DOD, title: 'Duplicate Trend DoD' },
    { id: ArrangementCronAdminPerformanceSectionId.PERFORMANCE_DISTRIBUTION_SUCCESS, title: 'Performance Distribution - Admin Success Rate' },
    { id: ArrangementCronAdminPerformanceSectionId.RECOVERY_EFFICIENCY, title: 'Recovery Efficiency' },
    { id: ArrangementCronAdminPerformanceSectionId.REPEAT_ARRANGEMENT_PATTERN, title: 'Repeat Arrangement Pattern Analysis' },
    { id: ArrangementCronAdminPerformanceSectionId.ADMIN_WORKLOAD_VS_RECOVERY, title: 'Admin Workload vs Recovery Output' },
    { id: ArrangementCronAdminPerformanceSectionId.ADMIN_PRODUCTIVITY_VS_RECOVERY, title: 'Admin Productivity vs Recovery Yield' },
    { id: ArrangementCronAdminPerformanceSectionId.DUPLICATE_ENTRIES_BY_ADMIN, title: 'Duplicate Entries by Admin (Top 5)' },
    { id: ArrangementCronAdminPerformanceSectionId.REPEAT_ARRANGEMENT_INTENSITY_DOD, title: 'Repeat Arrangement Intensity DoD' },
    { id: ArrangementCronAdminPerformanceSectionId.ADMIN_DUPLICATE_EXPOSURE, title: 'Admin Duplicate Exposure' },
    { id: ArrangementCronAdminPerformanceSectionId.DETAILED_DUPLICATE_ANALYSIS, title: 'Detailed Duplicate Analysis' },
    { id: ArrangementCronAdminPerformanceSectionId.WORST_YEAR, title: 'WORST YEAR' },
    { id: ArrangementCronAdminPerformanceSectionId.BEST_YEAR, title: 'BEST YEAR' },
    { id: ArrangementCronAdminPerformanceSectionId.LATEST_YEAR, title: 'LATEST YEAR' },
  ],
};

export const ARRANGMENT_CRON_TAB_SECTION_IDS: ArrangmentCronSectionId[] = [
  ArrangmentCronSectionId.OVERVIEW,
  ArrangmentCronSectionId.TRENDS_RECOVERY,
  ArrangmentCronSectionId.ADMIN_PERFORMANCE,
];

/** Default col-span per section id (12-col grid). Mirrors backend `default_cols`. */
export const ARRANGMENT_CRON_DEFAULT_COL_SPAN: Record<string, number> = {
  [ArrangementCronOverviewSectionId.SYSTEM_INTEL]: 12,
  [ArrangementCronOverviewSectionId.SCHEDULED_TODAY]: 6,
  [ArrangementCronOverviewSectionId.RECENT_ATTEMPTS]: 6,
  [ArrangementCronOverviewSectionId.KPI_SUMMARY]: 12,
  [ArrangementCronOverviewSectionId.TIME_GAP_DISTRIBUTION]: 12,
  [ArrangementCronOverviewSectionId.QUICK_ACTION]: 12,
  [ArrangementCronOverviewSectionId.AR_AGING_OVERVIEW]: 12,
  [ArrangementCronOverviewSectionId.MONTHLY_DISTRIBUTION]: 6,
  [ArrangementCronOverviewSectionId.CREATION_LIFECYCLE]: 6,
  [ArrangementCronOverviewSectionId.CONTRACT_STATUS_CHART]: 12,
  [ArrangementCronOverviewSectionId.METRIC_ANOMALIES]: 12,
  [ArrangementCronOverviewSectionId.ADMIN_DUPLICATES_TABLE]: 12,
  [ArrangementCronTrendsSectionId.STATS]: 12,
  [ArrangementCronTrendsSectionId.RECOVERY_AMOUNT]: 12,
  [ArrangementCronTrendsSectionId.CRITICAL_INSIGHTS]: 12,
  [ArrangementCronTrendsSectionId.MONTH_RECOVERY_PERFORMANCE]: 6,
  [ArrangementCronTrendsSectionId.ARRANGEMENT_TYPES]: 6,
  [ArrangementCronTrendsSectionId.SUCCESS_FAILURE_TIME]: 6,
  [ArrangementCronTrendsSectionId.SCHEDULE_RECOVERED_AMOUNT]: 6,
  [ArrangementCronTrendsSectionId.SUCCESS_RATE_COMPARISON_BY_TYPE]: 6,
  [ArrangementCronTrendsSectionId.ARRANGEMENT_CATEGORIES]: 6,
  [ArrangementCronTrendsSectionId.RECOVERY_VALUE_ATTEMPT]: 6,
  [ArrangementCronTrendsSectionId.RECOVERY_EXECUTION_TIMING]: 6,
  [ArrangementCronTrendsSectionId.YOY_PERFORMANCE]: 12,
  [ArrangementCronAdminPerformanceSectionId.STATS_SUMMARY_OVERVIEW]: 12,
  [ArrangementCronAdminPerformanceSectionId.TOP_PERFORMER]: 4,
  [ArrangementCronAdminPerformanceSectionId.DUPLICATE_CRISIS]: 4,
  [ArrangementCronAdminPerformanceSectionId.AVG_RECOVERY_PER_ADMIN]: 4,
  [ArrangementCronAdminPerformanceSectionId.DUPLICATE_ENTRY_TREND_OVER_TIME]: 6,
  [ArrangementCronAdminPerformanceSectionId.DUPLICATE_TREND_DOD]: 6,
  [ArrangementCronAdminPerformanceSectionId.PERFORMANCE_DISTRIBUTION_SUCCESS]: 6,
  [ArrangementCronAdminPerformanceSectionId.RECOVERY_EFFICIENCY]: 6,
  [ArrangementCronAdminPerformanceSectionId.REPEAT_ARRANGEMENT_PATTERN]: 12,
  [ArrangementCronAdminPerformanceSectionId.ADMIN_WORKLOAD_VS_RECOVERY]: 12,
  [ArrangementCronAdminPerformanceSectionId.ADMIN_PRODUCTIVITY_VS_RECOVERY]: 12,
  [ArrangementCronAdminPerformanceSectionId.DUPLICATE_ENTRIES_BY_ADMIN]: 6,
  [ArrangementCronAdminPerformanceSectionId.REPEAT_ARRANGEMENT_INTENSITY_DOD]: 6,
  [ArrangementCronAdminPerformanceSectionId.ADMIN_DUPLICATE_EXPOSURE]: 12,
  [ArrangementCronAdminPerformanceSectionId.DETAILED_DUPLICATE_ANALYSIS]: 12,
  [ArrangementCronAdminPerformanceSectionId.WORST_YEAR]: 4,
  [ArrangementCronAdminPerformanceSectionId.BEST_YEAR]: 4,
  [ArrangementCronAdminPerformanceSectionId.LATEST_YEAR]: 4,
};

/** Maps admin-performance chart item ids to layout section ids. */
export function adminChartItemSectionId(chartItemId: string): string {
  const mapped = {
    'duplicate-over-time': ArrangementCronAdminPerformanceSectionId.DUPLICATE_ENTRY_TREND_OVER_TIME,
    'duplicate-yoy': ArrangementCronAdminPerformanceSectionId.DUPLICATE_TREND_DOD,
    'performance-distribution': ArrangementCronAdminPerformanceSectionId.PERFORMANCE_DISTRIBUTION_SUCCESS,
    'recovery-efficiency': ArrangementCronAdminPerformanceSectionId.RECOVERY_EFFICIENCY,
    'repeat-pattern': ArrangementCronAdminPerformanceSectionId.REPEAT_ARRANGEMENT_PATTERN,
    'admin-workload': ArrangementCronAdminPerformanceSectionId.ADMIN_WORKLOAD_VS_RECOVERY,
    'admin-productivity': ArrangementCronAdminPerformanceSectionId.ADMIN_PRODUCTIVITY_VS_RECOVERY,
    'duplicates-by-admin': ArrangementCronAdminPerformanceSectionId.DUPLICATE_ENTRIES_BY_ADMIN,
    'repeat-intensity': ArrangementCronAdminPerformanceSectionId.REPEAT_ARRANGEMENT_INTENSITY_DOD,
  } as Record<string, string>;
  return mapped[chartItemId] ?? chartItemId;
}
